import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { differenceBy, groupBy } from 'lodash'
import { withDragDropContext } from '../drag-n-drop/dnd'
import SortableColumn from './sortable-column'
import './sortable-columns.css'


const propTypes = {
  items: PropTypes.array.isRequired,
  itemType: PropTypes.string.isRequired,
  Element: PropTypes.object.isRequired,
  itemKey: PropTypes.string,
  useHandle: PropTypes.bool,
  width: PropTypes.number,
}

const defaultProps = {
  itemKey: 'id',
  useHandle: false,
  width: 1,
}

// @withDragDropContext
class SortableColumns extends Component {
  constructor(props) {
    super(props)
    const columnItems = props.items.map((item) => ({ ...item, column: 0 }))

    this.state = { items: columnItems }
    this.columns = []
  }

  static getDerivedStateFromProps(props, state) {
    const { items, itemKey } = props
    const prevItems = state.items

    if (items.length > prevItems.length) {
      const newItems = differenceBy(items, prevItems, itemKey)

      const columnNewItems = newItems.map((item) => ({ ...item, column: 0 }))
      return {
        ...state,
        items: [...columnNewItems, ...state.items],
      }
    } if (items.length < prevItems.length) {
      const poppedItems = differenceBy(prevItems, items, itemKey).map((item) => item[itemKey])
      const newItems = prevItems.filter((item) => !poppedItems.includes(item[itemKey]))

      return {
        ...state,
        items: newItems,
      }
    }

    return state
  }

  componentDidUpdate(prevProps, prevState) {
    const { items } = this.state
    const { width } = this.props
    const { items: prevItems } = prevState
    const { width: prevWidth } = prevProps

    const wDiff = width - prevWidth
    if (wDiff < 0) {
      const deletedColumns = []
      for (let i = prevWidth - 1; i >= width; i--) {
        deletedColumns.push(i)
      }
      const newItems = items.map((item) => ({
        ...item,
        column: deletedColumns.includes(item.column) ? width - 1 : item.column,
      }))
      this.setState({ items: newItems })
    }
    // ***** experiments with auto distributing columns in sidebar
    // const iDiff = items.length - prevItems.length
    // if(wDiff !== 0 || iDiff !== 0){
    //   const perColumn = Math.floor(items.length/width)
    //   const columnItems = items.map((item,i)=>{
    //     item.column = (i+1) <= perColumn ? 0 : (i+1) <= perColumn*2 ? 1 : width-1
    //     return item
    //     //generic for any width:
    //     /*let column;
    //       for(let j = 0; j<width; j++){
    //         if((i+1)<=perColumn*(j+1) || (j+1) === width){
    //           column = j
    //           break;
    //         }
    //       } */
    //   })
    //   this.setState({ items: columnItems })
    // }

    const prevColItems = groupBy(prevItems, 'column')
    const colItems = groupBy(items, 'column')

    const keys = Object.keys(colItems)

    keys.forEach((key) => {
      if (prevColItems[key] && prevColItems[key].length < colItems[key].length) {
        this.columns[key].scrollTop = 0
      }
    })
  }

  moveColumn = (moveItem, newColumn) => {
    const { itemKey } = this.props

    const newItems = this.state.items.filter((item) => item[itemKey] !== moveItem[itemKey])
    newItems.unshift({ ...moveItem, column: newColumn })

    this.setState({ items: newItems })
  }

  setRef = (index) => (ref) => {
    this.columns[index] = ref
  }

  render() {
    const { items } = this.state
    const { itemKey, itemType, Element, useHandle, width } = this.props
    const itemsByColumn = groupBy(items, 'column')
    const columns = []
    for (let i = 0; i < width; i++) {
      const columnItems = itemsByColumn[i] || []
      columns.push((
        <div key={i} className="column" ref={(ref) => { this.columns[i] = ref }}>
          <SortableColumn
            columnIndex={i}
            items={columnItems}
            itemKey={itemKey}
            itemType={itemType}
            Element={Element}
            useHandle={useHandle}
            axis='y'
            moveColumn={this.moveColumn}
            setRef={this.setRef}
          />
        </div>
      ))
    }

    return (
      <div className="columns">
        {columns}
      </div>
    )
  }
}

SortableColumns.propTypes = propTypes

SortableColumns.defaultProps = defaultProps

export default withDragDropContext(SortableColumns)
